import { ROUTES } from '@/app/config/constants';
import type { AppRoute } from '@/app/config/constants';

/**
 * Where a role starts after signing in.
 *
 * Every role lands on the dashboard, with one exception: Mega Admin provisions
 * the tenant an Admin then works inside, so it starts on Organization Setup —
 * the only screen its sidebar offers and the only one its APIs are wired for.
 * Landing it on a dashboard its own menu does not list would be a page with
 * nothing on it and no entry marked active.
 *
 * Its own module rather than a second export from RoleLanding.tsx, which
 * react-refresh requires to export components only.
 */
export function getLandingRoute(isMegaAdmin: boolean): AppRoute {
  return isMegaAdmin ? ROUTES.ORGANIZATION_SETUP : ROUTES.DASHBOARD;
}
